/******************************************************************************\
 * :$
 *
 * Copyright(c) 2021 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: context
 *
 * Purpose: context for the app
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 08Dec2021 craig File created.
 \******************************************************************************/

import {IUser} from "../models/user/IUser";
import React from "react";

export const sessionName = "gs-session-user";

export const setSessionCookie = (session: any): void => {
    sessionStorage.clear();
    sessionStorage.setItem(sessionName, JSON.stringify(session));
};

export const getSessionCookie: any = () => {
    const sessionCookie = sessionStorage.getItem(sessionName);
    if (sessionCookie === 'undefined' || sessionCookie === null) {
        //create a sesson on the backend
        return getGuestCookie();

    }
    else {
        return JSON.parse(sessionCookie);
    }
};

export const getGuestCookie: any = () => {
    const guestUser : IUser = {
        UserID: -1,
        //Name: "Guest",
        FirstName: "Guest",
        LastName: "Guest",
        EmailAddress: "foo@foo.foo",
        //Username: "Guest",
        PhoneNumber: "555-555-5555",
        Title: "",
        Organization: "",
        RoleID: 0,
        Role: {
            RoleID: 0,
            Role: "Guest"
        },
        Attested: false,
        Authenticated: false,
        LoginMsg: ""
    }
    setSessionCookie(guestUser);
    return guestUser;
}

export const GSContext = React.createContext(getGuestCookie);